<template>
  <div class="container-fluid">
    <div v-if="hasError" class="border border-danger Rounded">
      <span class="w-100 text-center">
        <h4>مشکلی بوجود آمده است</h4>
      </span>
    </div>
    <div v-else class="row px-0">
      <div class="col-12 row px-0 mt-1" v-for="(item, index) in ScoresList" :key="index">
        <div class="col-xl-3 small col-12 mx-0 Pointer" :data-title="item.countScoresAnswers + ' پاسخ در ' + item.ticketCount + ' تیکت '"><span class="fas fa-star text-warning"></span> &nbsp; {{ item.nameUser }}</div>
        <div class="col-xl-8 col-12 mx-0">
          <b-progress class="sidebarProgress progress-xs mt-1" :variant="'info'" :value="item.averageScore" :max="5" />
        </div>
        <div class="col-xl-1 text-nowrap d-xl-block small d-none text-secondary">{{ Math.round(item.averageScore * 100) / 100 }} از 5</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ScoresList: [],
      hasError: false,
    }
  },
  created() {
    var axios = { Method: 'POST', Action: 'Ticket/GetallScores', ArryfildValue: { Id: this.$session.get('Menu').filter((x) => x.RouteName == 'ticketScore')[0].isMojaz == 1 ? 0 : this.$session.get('UserInfo').tblUserId } }
    this.$PostData(axios).then((result) => {
      if (result.status == 'success') {
        this.ScoresList = result.data
      } else {
        this.hasError == true
      }
    })
  },
}
</script>
<style></style>
